<template>
  <div class="category-info-modal">
    <!-- Button trigger modal -->
    <div class="d-flex row mt-3">
      <a
        data-bs-toggle="modal"
        data-bs-target="#categoryInfoModal"
        style="
          cursor: pointer;
          text-align: left;
          font-family: oxygen-bold;
          font-size: 12pt;
        "
        class="filter-link float-end mt-2"
      >
        {{ title }}
      </a>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="categoryInfoModal"
      tabindex="-1"
      aria-labelledby="categoryInfoModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content rounded-0" style="border: none">
          <div
            class="modal-header rounded-0"
            style="
              background-color: var(--deepgreen);
              color: white;
              padding: 10px 20px;
              border: none;
            "
          >
            <h5
              class="modal-title"
              id="categoryInfoModalLabel"
              style="font-family: oxygen-bold; font-size: 14pt"
            >
              {{ title }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body" style="border: none">
            <slot></slot>
          </div>
          <div
            class="modal-footer rounded-0 justify-content-around"
            style="border-top: none; border-bottom: 10px solid var(--deepgreen)"
          >
            <button
              v-if="categoryChosen"
              @click="$emit('clearCategory')"
              @keyup.enter="$emit('clearCategory')"
              class="btn btn-secondary"
              style="width: 40%"
            >
              {{ clearCategoryTitle }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              style="width: 40%"
            >
              {{ btnText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["clearCategory"],
  props: {
    title: {
      type: String,
      default: "Title",
    },
    btnText: {
      type: String,
      default: "Luk",
    },
    clearCategoryTitle: {
      type: String,
      default: "Tilbage",
    },
    categoryChosen: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
};
</script>

<style></style>
